export default __webpack_public_path__ + "66074a2bd1b513beffe7b54920070f59.png";